import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  GetRolesArcgisResult,
  RoleArcgis
} from '../models';
import { LocalStorageService } from './local-storage.service';
import { ConfigService } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class RolArcgisService {
  constructor(protected http: HttpClient, protected localStorageService: LocalStorageService) {
  }

  getRoles(tokenSistema: string, token: string): Observable<{roles: RoleArcgis[]}> {
    return this.http.post<{ queryResults: GetRolesArcgisResult }>(this.getCoreUrl('queryRolesUsuarioArcgis'),
      { tokenSistema, tokenUsuario: token }
    ).pipe(
      map(response => {
        if (response.queryResults.success) {
          return {roles: response.queryResults.roles};
        }
        return null;
      })
    );
  }

  /**
 * Return url from method in core.
 * @param method to url.
 */
  protected getCoreUrl(method: string): string {
    const apiWebServiceUrl = ConfigService.config.apiWebServiceUrl;
    return `${apiWebServiceUrl}/${method}`;
  }

}
